import { __rest } from "tslib";
import React from 'react';
import cn from 'classnames';
import styles from './BaseInput.module.scss';
const BaseInput = React.forwardRef((_a, ref) => {
    var { isInvalid, isExtraInnerInputPaddingEnabled = false, isInputTextSmall = false, inputSize = 'large', className, isFCSolution = false } = _a, restProps = __rest(_a, ["isInvalid", "isExtraInnerInputPaddingEnabled", "isInputTextSmall", "inputSize", "className", "isFCSolution"]);
    return (React.createElement("input", Object.assign({ ref: ref, className: cn(styles.input, className, isInvalid && styles.error, isExtraInnerInputPaddingEnabled && styles.extraInnerPadding, isInputTextSmall && styles.textSmall, inputSize === 'small' && styles.inputSmall, isFCSolution && styles.inputFC) }, restProps)));
});
export default BaseInput;
//# sourceMappingURL=BaseInput.js.map